import "./assets/styles/reset.scss";
import "./assets/styles/global.scss";

import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import {RouterProvider} from "react-router-dom";
import router from "./router/router";
import "./i18n";
import {Provider} from "react-redux";
import {setupStore} from "./store/store";
import Spinner from "./components/Spiner/Spinner";

const store = setupStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <Provider store={store}>
        <Suspense fallback={<Spinner/>}>
            <RouterProvider router={router} />
        </Suspense>
    </Provider>
);
